// @ts-check
import Vue from "vue";
import Vuex from "vuex";
import moment from "moment-timezone";
import { Settings } from "luxon";

Vue.use(Vuex);

const strings = {
  fr: require("./i18n/fr.json"),
  en: require("./i18n/en.json")
};

const currencySymbolPosition = {
  fr: "after",
  en: "before"
};

let check = function(fr, en, parent) {
  let gotIn = false;
  for (let key in fr) {
    if (typeof en[key] === "undefined") {
      console.log("[LOCALE ERROR] Key '" + (parent ? parent + "." + key : key) + "' missing in lang 'en'");
    } else if (typeof fr[key] === "object") {
      check(fr[key], en[key], parent ? parent + "." + key : key);
      gotIn = true;
    }
  }
  for (let key in en) {
    if (typeof fr[key] === "undefined") {
      console.log("[LOCALE ERROR] Key '" + (parent ? parent + "." + key : key) + "' missing in lang 'fr'");
    } else if (typeof en[key] === "object" && !gotIn) {
      check(fr[key], en[key], parent ? parent + "." + key : key);
    }
  }
}
check(strings.fr, strings.en);

let localizeStore = new Vuex.Store({
  state: {
    locale: "en",
    currencySymbolPosition: currencySymbolPosition,
    strings: strings
  },
  mutations: {
    setLocale(state, locale) {
      if (["fr", "en"].indexOf(locale) === -1) {
        locale = "en";
      }
      state.locale = locale;
      Settings.defaultLocale = locale;
      localStorage.setItem("ishopv3-backend-locale", locale);
      moment.locale(locale);
    }
  },
  getters: {
    get: (state) => (id, opt) => {
      if (!id) {
        return "";
      }
      let split = id.split(".");
      let root = state.strings[state.locale];
      for (let key of split) {
        if (root == null) {
          break;
        }
        root = root[key];
      }
      if (root == null && (!opt || !opt.noConsole)) {
        console.log("[LOCALE ERROR] Could not find locale string with key '" + id + "'");
      }
      return root || id;
    },
    getTransObject: (state, getters) => (id) => {
      let obj = {};
      for (let locale of getters.getLocales) {
        obj[locale] = getters.get(id)
      }
      return obj
    },
    getLocales: (state) => {
      return Object.keys(state.strings);
    },
    getFromObject: (state) => (obj = {}) => {
      if (!obj) {
        return;
      }
      return obj[state.locale] || obj.fr || obj.en;
    },

    getCurrencySymbolPosition: (state) => {
      return state.currencySymbolPosition[state.locale];
    },

    getCurrencySymbol: (state) => (amount, currency, decimals = 2) => {
      let symbol = "";
      let symbolText = "";

      if (typeof amount !== "number" && !amount) {
        return "";
      }

      switch (currency ? currency.toUpperCase() : null) {
        case "GBP":
          symbol = "£";
          break;
        case "EUR":
          symbol = "€";
          break;
        case "CAD":
          symbol = "$";
          symbolText = "CA";
          break;
        case "USD":
          symbol = "$";
          symbolText = "US";
          break;
        default:
          symbol = "$";
          break;
      }

      amount = amount.toFixed(decimals);

      switch (state.currencySymbolPosition[state.locale]) {
        case "before":
          return symbolText + symbol + " " + amount;
        case "after":
          return amount + " " + symbol + symbolText;
        default:
          return symbolText + symbol + " " + amount;
      }
    }
  }
});

let plugin = {
  install(Vue, options = {}) {
    Vue.prototype.$t = localizeStore.getters.get;
    Vue.prototype.$to = localizeStore.getters.getFromObject;
    Vue.prototype.$ts = localizeStore;
    Vue.prototype.$tc = localizeStore.getters.getCurrencySymbol;
    window.translate = localizeStore.getters.get;
  }
};

export { plugin as Localize, localizeStore as LocalizeStore };
